const updateAccessInLocalStorage = (accessArray) => {
  let user = JSON.parse(localStorage.getItem("jandle-admin"));
  user = { ...user, access: accessArray };
  localStorage.setItem("jandle-admin", JSON.stringify(user));
};

export default updateAccessInLocalStorage;
